import { PauseCircle } from "lucide-react";
import "../space-live.css";

export function SpacePausedModal({ isVisible }: { isVisible: boolean }) {
  if (!isVisible) return null;
  return (
    <div className="absolute inset-0 z-[400] flex items-center justify-center bg-black/40 backdrop-blur-sm pointer-events-auto">
      <div className="et-space-paused-card relative rounded-[11px] px-10 py-8 shadow-xl max-w-sm w-full text-center">
        <PauseCircle className="mx-auto mb-4" size={48} />
        <p className="text-lg font-semibold font-mulish mb-2">
          Space is paused
        </p>
        <p className="text-sm font-mulish">
          Your teacher has paused the session. Hang tight — it'll resume
          shortly.
        </p>
      </div>
    </div>
  );
}
